import { FORM_ERROR_SELECTOR } from '../../imt/components/Instructor/FormSections/FormSections.common';

/**
 * Scrolls to help users find form validation errors.
 * @param formErrorSelector - CSS class selector for the element to scroll to
 * @param scrollToTop - If true, scrolls container to top; if false, scrolls into view
 */
export const handleScrollToError = (
    formErrorSelector: string = FORM_ERROR_SELECTOR,
    scrollToTop: boolean = false,
) => {
    const scroll = () => {
        const element = document.querySelector(`.${formErrorSelector}`);

        if (!element) return false;

        if (scrollToTop) {
            // Scroll container to top
            element.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        } else {
            // Scroll directly to the element
            element.scrollIntoView({
                behavior: 'smooth',
            });
        }

        return true;
    };

    // Callers validate the form and then call this immediately, so the render
    // that adds the error class has usually not committed yet: React 18 batches
    // the validation state update. Before React 18 it flushed synchronously,
    // because awsui v2 controls dispatch native DOM events rather than React
    // synthetic ones and so fell outside React's batching. Retry once the commit
    // has landed when the first attempt finds nothing.
    if (!scroll()) {
        setTimeout(scroll, 0);
    }
};
